import { useState, useEffect } from 'react';
import * as React from 'react'
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  Snackbar,
  TextField,
  IconButton
} from '@material-ui/core';
import { GET_ROLE, POST_USER } from '../../utils/Constants';
import restApiService from '../../services/restService';
import { User } from 'react-feather';
import * as Yup from 'yup';
import CloseIcon from "@material-ui/icons/Close";
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';

const UserCreateFormComponent = (props) => {
  const { callService } = restApiService();
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    email: '',
    role: ''
  });
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    let isMounted = true;
    callService('GET', GET_ROLE, {}, true)
      .then(response => {
        if (isMounted)
          if (response.status == 200) {
            setRoles([...response.data], response.data)
          } else {
            setMessage(response.data.message);
            handleToOpen();
          }
      });
    return () => { isMounted = false };
  }, [])

  const handleToClose = () => {
    setOpen(false);
  };

  const handleToOpen = () => {
    setOpen(true);
  };

  const delay = (function () {
    var timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();

  return (
    <Container maxWidth={false}>
      <Formik
        enableReinitialize
        initialValues={{ ...user }}
        validationSchema={Yup.object().shape({
          firstName: Yup.string().max(255).required('First name is required'),
          lastName: Yup.string().max(255).required('Last name is required'),
          roles: Yup.string().max(255).required('Role is required'),
          email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
          password: Yup.string().max(255).required('Password is required').min(8, 'Password is too short - should be 8 chars minimum.').matches(
            /^.*((?=.*[A-Z]){1}).*$/, "Password must contain at least 1 uppercase characters."
          ),
          confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match')
        })}
        onSubmit={(values, actions) => {
          let request = {
            firstName: values.firstName,
            lastName: values.lastName,
            password: values.password,
            confirmPassword: values.confirmPassword,
            email: values.email,
            roleIds: [parseInt(values.roles)]
          }
          callService('POST', POST_USER, { data: request }, true)
            .then(response => {
              if (response.status === 200) {
                handleToOpen();
                setMessage("The user " + request.email + " has been created successfully");
                delay(function () {
                  navigate('/app/users');
                }, 3000);
              } else {
                var errors = 'ERRORS: ';
                if (response.data.errors) {
                  for (var e of response.data.errors) {
                    errors = errors + ' ' + e + '';
                  }
                } else {
                  errors = errors + response.data.error;
                }
                setMessage(errors)
                handleToOpen();
                actions.setSubmitting(false);
              }
            });
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          values
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      error={Boolean(touched.firstName && errors.firstName)}
                      helperText={touched.firstName && errors.firstName}
                      onBlur={handleBlur}
                      label="First name"
                      name="firstName"
                      onChange={handleChange}
                      required
                      value={values.firstName}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      error={Boolean(touched.lastName && errors.lastName)}
                      helperText={touched.lastName && errors.lastName}
                      onBlur={handleBlur}
                      label="Last name"
                      name="lastName"
                      onChange={handleChange}
                      required
                      value={values.lastName}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      error={Boolean(touched.email && errors.email)}
                      helperText={touched.email && errors.email}
                      onBlur={handleBlur}
                      label="Email Address"
                      name="email"
                      onChange={handleChange}
                      required
                      value={values.email}
                      variant="outlined"
                      type="email"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      id="select-role"
                      name="role"
                      error={Boolean(touched.roles && errors.roles)}
                      helperText={touched.roles && errors.roles}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue('roles', e.target.value)
                        handleChange(e)
                      }
                      }
                      label="Select Role"
                      value={values.roles || ""}
                      required
                      variant="outlined"
                      select
                      fullWidth
                    >
                      {roles.map((option) => (
                        <MenuItem
                          key={option.id}
                          value={option.id}
                        >
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      error={Boolean(touched.password && errors.password)}
                      helperText={touched.password && errors.password}
                      onBlur={handleBlur}
                      label="Password"
                      name="password"
                      onChange={handleChange}
                      required
                      value={values.password}
                      variant="outlined"
                      type="password"
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                      helperText={touched.confirmPassword && errors.confirmPassword}
                      onBlur={handleBlur}
                      label="Confirm Password"
                      name="confirmPassword"
                      onChange={handleChange}
                      required
                      value={values.confirmPassword}
                      variant="outlined"
                      type="password"
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  p: 2
                }}
              >
                <Button
                  style={{ marginRight: 10 }}
                  color="primary"
                  variant="contained"
                  onClick={() => { navigate('/app/users') }}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={isSubmitting}
                  type="submit"
                  onPress={isSubmitting = true}
                >
                  Save
                </Button>
              </Box>
            </Card>
          </form>
        )}
      </Formik>
      <Snackbar
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
          backgroundColor: "red"
        }}
        open={open}
        autoHideDuration={3000}
        message={message}
        onClose={handleToClose}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleToClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </Container>
  );
};

export default UserCreateFormComponent;
